module.exports = __webpack_public_path__ + "img/3fa4c1e.png";